module.exports = __webpack_public_path__ + "static/media/seguroviaje.c9cbcefa.jpg";